import '../scss/app.scss';
import { initMenuOverlay } from './components/menu-overlay';
import { initArtistGallery } from './components/artist-gallery';

initMenuOverlay();
initArtistGallery();
